var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHappy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "#F9F7FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4158_34520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 30.0011C50 41.0513 41.0492 50.0022 29.9989 50.0022C18.9487 50.0022 10 41.0492 10 30.0011C10 18.953 18.9508 10 30.0011 10C41.0513 10 50.0022 18.9508 50.0022 30.0011M48.0914 29.9837C48.0914 20.0092 39.9995 11.9173 30.0249 11.9173C20.0504 11.9173 11.9585 20.0092 11.9585 29.9837C11.9585 39.9583 20.0504 48.0502 30.0249 48.0502C39.9995 48.0502 48.0914 39.9583 48.0914 29.9837Z",
    fill: "#1E1E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9343 28.668C42.1985 28.668 42.414 28.8773 42.414 29.1477V29.5197C42.4364 36.2743 37.0457 41.7727 30.3704 41.797H30.1996C23.5223 41.8194 18.0849 36.3596 18.0625 29.5969V29.2249C18.0625 28.9607 18.28 28.7452 18.5422 28.7452L41.9343 28.668ZM40.5012 30.4567L19.898 30.3795C19.8513 30.3795 19.8126 30.4181 19.8126 30.4649C19.7964 35.6624 24.4065 39.8904 30.1061 39.9148H30.2301C35.9318 39.9371 40.5704 35.7397 40.5866 30.5421C40.5866 30.4953 40.548 30.4567 40.5012 30.4567Z",
    fill: "#1E1E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9909 21.9178C24.3789 21.7855 25.6846 22.7029 26.9078 24.6787C27.1464 25.0669 27.1225 25.4313 26.8167 25.7696C26.7083 25.9019 26.602 25.9844 26.4936 26.0169C25.8581 26.2143 25.4026 26.0993 25.1467 25.6699C24.4028 24.4228 23.6849 23.8025 22.9974 23.8177C22.3034 23.8003 21.592 24.4293 20.8567 25.6851C20.6008 26.1145 20.154 26.2316 19.5099 26.0408C19.4101 26.0082 19.3038 25.9258 19.1867 25.7935C18.8809 25.4552 18.8484 25.0908 19.087 24.7026C20.3015 22.7181 21.5985 21.7942 22.9887 21.9178H22.9909Z",
    fill: "#1E1E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0813 21.9175C38.5778 21.8091 39.916 22.8935 41.1067 25.1664C41.3041 25.546 41.0416 26.0101 40.5862 26.0839L40.2804 26.1338C39.6926 26.2248 39.2393 25.9776 38.9335 25.3725C38.4304 24.3727 37.8014 23.8521 37.0575 23.8261C36.3136 23.8348 35.6694 24.3293 35.1402 25.3226C34.8171 25.9169 34.3638 26.1576 33.776 26.0492L33.4702 25.9906C33.0147 25.9082 32.7588 25.4376 32.9735 25.0645C34.2141 22.8241 35.5848 21.7744 37.0813 21.9154V21.9175Z",
    fill: "#1E1E1D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4158_34520"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappy);
export default __webpack_public_path__ + "static/media/happy.637814bbf0166889afd84a5dee259607.svg";
export { ForwardRef as ReactComponent };